export const cleanPhoneNumber = (phone: string): string =>
  phone.replace(/[\s()-]/g, '');
